import MiscellaneousItem from "@/modules/invoices/models/MiscellaneousItem.model";
import _ from "lodash";
import cloneDeep from "lodash/cloneDeep";

export const InvoiceModalMixin = {
  methods: {
    onNewMiscellaneousItemClick() {
      this.model.miscellaneous_items.push(new MiscellaneousItem({taxable: true}))
    },
    onMiscellaneousItemDelete(index) {
      for (let i = 0; i < this.model.miscellaneous_items.length; i++) {
        if (i === index) {
          this.model.miscellaneous_items.splice(i, 1);
          break;
        }
      }
    },
    onShippingAddressEditClick() {
      this.showAddressModal({
        object: this.model.invoice_shipping_address ? this.model.invoice_shipping_address : {type: 'shipping'},
        customerUuid: this.customerUuid,
        modalReference: cloneDeep(this.modalUuid)
      })
    },
    onBillingAddressEditClick() {
      this.showAddressModal({
        object: this.model.invoice_billing_address ? this.model.invoice_billing_address : {type: 'billing'},
        customerUuid: this.customerUuid,
        modalReference: cloneDeep(this.modalUuid)
      })
    },
    setDefaultAddresses(billing_address, shipping_address) {
      if (shipping_address) {
        this.model.invoice_shipping_address = {
          address_1: shipping_address.address_1,
          address_2: shipping_address.address_2,
          city: shipping_address.city,
          county: shipping_address.county,
          state: shipping_address.state,
          zip_code: shipping_address.zip_code,
          email: shipping_address.email,
          phone: shipping_address.phone,
          first_name: shipping_address.first_name,
          last_name: shipping_address.last_name,
          type: 'shipping',
          country_code: shipping_address.country ? shipping_address.country.country_code : null,
          country: shipping_address.country,
        }
      } else {
        this.model.invoice_shipping_address = null
      }

      if (billing_address) {
        this.model.invoice_billing_address = {
          address_1: billing_address.address_1,
          address_2: billing_address.address_2,
          city: billing_address.city,
          county: billing_address.county,
          state: billing_address.state,
          zip_code: billing_address.zip_code,
          email: billing_address.email,
          phone: billing_address.phone,
          first_name: billing_address.first_name,
          last_name: billing_address.last_name,
          type: 'billing',
          country_code: billing_address.country ? billing_address.country.country_code : null,
          country: billing_address.country,
        }
      } else  {
        this.model.invoice_billing_address = null
      }
    },
  },
  mounted() {
    this.$evBus.$on(`onAddressUpdate-${this.modalUuid}`, ({object}) => {
      if (object.type === 'billing') {
        this.model.invoice_billing_address = _.cloneDeep(object)
      } else {
        this.model.invoice_shipping_address = _.cloneDeep(object)
      }
      if (this.calculateData !== undefined) {
        this.calculateData();
      }
    })
  },
  beforeDestroy() {
    this.$evBus.$off(`onAddressUpdate-${this.modalUuid}`)
  }
}

